import { render, staticRenderFns } from "./TOCConfiguration.vue?vue&type=template&id=f64d174e&"
import script from "./TOCConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TOCConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports